module.exports = __webpack_public_path__ + "img/aParty_032523_E.92b63e68.jpg";